<nav class="navbar navbar-expand-lg bg-primary fixed-top" data-bs-theme="dark">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/portal/home"><i class="bi bi-grid-1x2-fill me-1"
        aria-hidden="true"></i>Portal</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#ptNavbarSupportedContent"
      aria-controls="ptNavbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="ptNavbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" routerLink="/portal/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><i class="bi bi-house-door me-1"
              aria-hidden="true"></i>Inicio</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/portal/brand-device" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><i class="bi bi-bookmark-star me-1"
              aria-hidden="true"></i>Dispositivos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/portal/brand-processor" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><i class="bi bi-cpu me-1"
              aria-hidden="true"></i>Procesadores</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/portal/graphic-card" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><i class="bi bi-gpu-card me-1"
              aria-hidden="true"></i>Tarjetas Gráficas</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/portal/operating-system" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><i class="bi bi-windows me-1"
              aria-hidden="true"></i>Sistemas Operativos</a>
        </li>
      </ul>
      <div class="d-flex gap-2">
        @if (authSession.isAuthenticated()) {
        @if (authSession.getUserName(); as userName) {
        <span class="navbar-text text-white align-self-center border border-light rounded px-2 py-1">{{ userName
          }}</span>
        }
        @if (sessionTimer.remainingTime(); as remainingTime) {
        <span class="navbar-text text-white align-self-center border border-light rounded px-2 py-1"><i
            class="bi bi-clock me-1"></i>{{ remainingTime }}</span>
        }
        <app-theme-toggle></app-theme-toggle>
        @if (authSession.isAdministrator()) {
        <a class="btn btn-outline-light" routerLink="/working/dashboard">Gestión</a>
        }
        <button class="btn btn-outline-light" type="button" (click)="logout()">Cerrar Sesión</button>
        } @else {
        <app-theme-toggle></app-theme-toggle>
        <div class="d-flex gap-2 guest-actions">
          <a class="btn btn-outline-light" routerLink="/login">Ingreso</a>
          <a class="btn btn-light" routerLink="/portal/register">Registro</a>
        </div>
        }
      </div>
    </div>
  </div>
</nav>
